import {
  LayoutDashboard,
  FolderKanban,
  Users,
  Briefcase,
  CreditCard,
  BarChart3,
  Settings,
  Activity,
} from "lucide-react";
import { REPORT_NAV_CHILDREN } from "./providerReports";

export const NAV_GROUPS = [
  {
    label: "Main",
    items: [
      {
        label: "Overview",
        description: "Your collections at a glance",
        icon: LayoutDashboard,
        path: "/dashboard",
        end: true,
      },
    ],
  },
  {
    label: "Portfolio & Cases",
    items: [
      {
        label: "Debt Portfolios",
        description: "Groups and Excel uploads for receivable books",
        icon: FolderKanban,
        path: "/dashboard/portfolios",
      },
      {
        label: "Customers",
        description: "Customer profiles and contact history",
        icon: Users,
        path: "/dashboard/customers",
      },
      {
        label: "Collection Cases",
        description: "Active cases and follow-ups",
        icon: Briefcase,
        path: "/dashboard/cases",
      },
    ],
  },
  {
    label: "Nurture & Recovery",
    items: [
      {
        label: "Payments",
        description: "Collections and payment tracking",
        icon: CreditCard,
        path: "/dashboard/payments",
      },
    ],
  },
  {
    label: "Insights",
    items: [
      {
        label: "Reports",
        description: "Portfolio, recovery, and reconciliation reports",
        icon: BarChart3,
        path: "/dashboard/reports",
        matchPath: "/dashboard/reports",
        children: REPORT_NAV_CHILDREN,
      },
    ],
  },
  {
    label: "Administration",
    items: [
      {
        label: "Settings",
        description: "Portal preferences and branding",
        icon: Settings,
        path: "/dashboard/settings",
      },
      {
        label: "Audit Trail",
        description: "Sign-ins, payments received, uploads, and profile changes",
        icon: Activity,
        path: "/dashboard/audit-trail",
      },
    ],
  },
];

function flattenNavItems(items) {
  const out = [];
  items.forEach((item) => {
    out.push(item);
    (item.children || []).forEach((child) => {
      if (Array.isArray(child.children) && child.children.length) {
        out.push(...child.children);
      } else {
        out.push(child);
      }
    });
  });
  return out;
}

export const ALL_NAV_ITEMS = flattenNavItems(NAV_GROUPS.flatMap((group) => group.items));

export function getPageMeta(pathname) {
  if (pathname.startsWith("/dashboard/audit-trail") || pathname.startsWith("/dashboard/activity")) {
    return {
      label: "Audit Trail",
      description: "Sign-ins, payments received, uploads, and profile changes",
      icon: Activity,
      path: "/dashboard/audit-trail",
    };
  }

  if (pathname.includes("/portfolios/") && pathname.includes("/uploads/")) {
    return {
      label: "Uploaded Accounts",
      description: "View imported debtor records",
      path: pathname,
    };
  }

  if (pathname.includes("/portfolios/") && pathname.endsWith("/upload")) {
    return {
      label: "Upload Excel",
      description: "Validate and import debtor accounts",
      path: pathname,
    };
  }

  const exact = ALL_NAV_ITEMS.find((item) => item.path === pathname);
  if (exact) {
    return {
      label: exact.label,
      description: exact.description || exact.purpose,
      icon: exact.icon,
      path: exact.path,
    };
  }

  if (pathname.startsWith("/dashboard")) {
    return ALL_NAV_ITEMS[0];
  }

  return {
    label: "Overview",
    description: "Your collections at a glance",
    icon: LayoutDashboard,
    path: "/dashboard",
  };
}
